import { render, staticRenderFns } from "./Add.html?vue&type=template&id=62960d8e&"
import script from "./Add.js?vue&type=script&lang=js&"
export * from "./Add.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports